import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Foot = ({ content }) => {
    return (
        <div className={styles.foot}>
            <img className={styles.footPic} src="https://x0.ifengimg.com/ucms/2025_17/25B00F8D66369CDACEC960B2EFA0529C2640284D_size657_w1920_h1337.png" />
            <div className={styles.footBox}>
                <a href={content?.brandInfo?.url} target="_blank" className={styles.footBrand}>
                    {content?.brandInfo?.bigImage && <img className={styles.footBrandBig} src={content.brandInfo.bigImage} />}
                    {content?.brandInfo?.smallImage && <img className={styles.footBrandSmall} src={content.brandInfo.smallImage} />}
                </a>
                {/* 往期回顾 */}
                <div className={styles.footReview}>
                    {content.previouseview.map((item, index) => {
                        const footReviewItemName = `footReviewItem${index + 1}`;

                        return (
                            <a href={item.url} target="_blank" key={index} className={`${styles[footReviewItemName]} ${styles.footReviewItem}`}>
                                <div className={styles.footReviewTitle}>{item.title}</div>
                                <img className={styles.footReviewPlay} src="https://x0.ifengimg.com/ucms/2025_17/1274C162CBFA3170C6C27BB60F6FCEF6FC434926_size1_w47_h47.png" />
                                <div className={styles.footReviewWatch}>点击观看</div>
                            </a>
                        );
                    })}
                </div>
                {/* 二维码 */}
                <div className={styles.footCode}>
                    {content.qrcodeList.map((item, index) => {
                        return (
                            <div key={index} className={styles.footCodeItem}>
                                <img className={styles.footCodePic} src={item.imageUrl} />
                                <div className={styles.footCodeText}>{item.imageTitle}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

Foot.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Foot);
